import styled from "styled-components";
import { useDispatch } from "react-redux";
import { Grid, Typography } from "@mui/material";

import LOGO from "../../assets/Mox-3.svg";
import { signOutMember } from "../../redux/slices/memberSlice";

const OuterGrid = styled(Grid)`
  padding-left: 13.19%;
  padding-right: 13.19%;
`;

const ImageDiv = styled.div`
  width: 320px;
  height: 160px;
`;

const Image = styled.img`
  height: inherit;
  width: inherit;
`;

const Font = styled(Typography)`
  font-weight: 700;
  font-size: 20px;
  cursor: pointer;
`;

export function Navbar() {
  const dispatch = useDispatch();

  return (
    <OuterGrid container spacing={2}>
      <Grid item xs style={{ paddingTop: "0px" }}>
        <ImageDiv>
          <Image alt="1" src={LOGO} />
        </ImageDiv>
      </Grid>

      {/* <Grid item alignSelf={"center"} fontWeight="bold" marginRight="20px">
        <Font>FAQ</Font>
      </Grid> */}

      <Grid item alignSelf={"center"} fontWeight="bold">
        <Font cursor="pointer" onClick={() => dispatch(signOutMember())}>
          Logout
        </Font>
      </Grid>
    </OuterGrid>
  );
}
